module.exports = __webpack_public_path__ + "img/vpn-4.9d3e8868.jpg";